import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X, ArrowRight } from "lucide-react";
import { PROMO } from "../../lib/promo";
import { PROMO_IDS } from "../../constants/testIds";

const STORAGE_KEY = "alae-promo-banner-dismissed";
const EASE = [0.22, 1, 0.36, 1];

export default function PromoBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!PROMO.enabled) return;
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    setVisible(true);
  }, []);

  if (!PROMO.enabled) return null;

  return (
    <AnimatePresence initial={false}>
      {visible && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.55, ease: EASE }}
          data-testid={PROMO_IDS.banner}
          className="relative overflow-hidden bg-umber text-linen"
        >
          <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-2.5 pr-12 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-center">
            <span className="text-[12px] md:text-[13px] text-linen/90">
              <span className="md:hidden">{PROMO.bannerTextShort}</span>
              <span className="hidden md:inline">{PROMO.bannerText}</span>
            </span>
            <Link
              to={`${PROMO.path}?from=top-banner`}
              data-testid={PROMO_IDS.bannerCta}
              className="group inline-flex items-center gap-1.5 text-[10px] md:text-[11px] tracking-[0.22em] uppercase text-linen underline underline-offset-4 decoration-linen/40 hover:decoration-linen transition-colors"
            >
              {PROMO.bannerCta}
              <ArrowRight
                size={13}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </Link>
          </div>

          <button
            type="button"
            aria-label="Dismiss grand opening notice"
            data-testid={PROMO_IDS.bannerClose}
            onClick={() => {
              sessionStorage.setItem(STORAGE_KEY, "1");
              setVisible(false);
            }}
            className="absolute top-1/2 -translate-y-1/2 right-2 md:right-4 text-linen/60 hover:text-linen transition-colors p-2 inline-flex items-center justify-center"
          >
            <X size={15} strokeWidth={1.6} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
